import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import { Container, Card } from 'reactstrap';
import useAwardsIndustryRecognition from '@/hooks/useAwardsIndustryRecognition';
import Link from "next/link"
import styles from './styles.module.scss';
import Marquee from "react-marquee-slider";

export const Awards = ({
    className,
    title,
    selectedItems,
    heading
}) => {

    const items = useAwardsIndustryRecognition();
    
    const filteredItems = selectedItems?.length > 0 ? items.filter((item) => selectedItems?.includes(item?.id)) : items;

    if (!filteredItems || !filteredItems.length > 0) {
        return null;
    }

    return (
        <section className={`${styles.root} ${className} overflow-hidden`}>
            <Container className="py-4 py-md-5">
                {title &&
                    <div className="mb-5 text-center">
                        <h2 className={`${heading} fw-bold`}>{title}</h2>
                    </div>
                }
                <div className="marquee-parent position-relative">
                    <Marquee
                        velocity={25}>
                        {filteredItems.map((item, index) => (
                            <Card key={index} className="rounded-0 bg-transparent border-0 align-items-center mx-5">
                                {item?.link ?
                                    <Link href={`${item?.link}`}>
                                        <a title={`${item?.title}`}>
                                            <SourceFlowImage
                                                src={item?.image}
                                                size="500x"
                                                alt={item?.title}
                                                width="100%"
                                                height="100%"
                                                className="card-img rounded-0 m-auto"
                                            />
                                        </a>
                                    </Link>
                                :
                                    <SourceFlowImage
                                        src={item?.image}
                                        size="500x"
                                        alt={item?.title}
                                        width="100%"
                                        height="100%"
                                        className="card-img rounded-0 m-auto"
                                    />
                                }
                            </Card>
                        ))}
                    </Marquee>
                </div>
            </Container>
        </section>
    )
}

export default Awards;
